import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";

const EfisModalCienciaOs = ({
  title,
  body,
  show,
  context,
  loadingConfirmationAction,
  primaryLabel,
  secondaryLabel,
  confirmationHandler,
  closeHandler,
}) => (
  <Modal show={show} onHide={() => closeHandler()} backdrop="static" keyboard={false}>
    <Modal.Header closeButton>
      <Modal.Title>{title || "Tem certeza disso?"}</Modal.Title>
    </Modal.Header>

    <Modal.Body>{typeof body === "string" ? <p>{body}</p> : body}</Modal.Body>

    <Modal.Footer>
      {loadingConfirmationAction ? (
        <Spinner animation="border" role="status" />
      ) : (
        <Button
          variant="primary"
          onClick={() => {
            confirmationHandler(context.sqAcaoFiscal, context.codigo);
          }}
        >
          {primaryLabel || "Confirmar"}
        </Button>
      )}
      <Button variant="light" onClick={() => closeHandler()}>
        {secondaryLabel || "Cancelar"}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default EfisModalCienciaOs;
